import { createContext, useContext, useMemo, useReducer } from 'react'

export const TYPES = {
  SET_TEMPLATE: 'SET_TEMPLATE',
  SET_TEMPLATE_MAPPER: 'SET_TEMPLATE_MAPPER',
  SET_DATA: 'SET_DATA',
  SET_MASTER: 'SET_MASTER',
  SET_DATA_FROM_API: 'SET_DATA_FROM_API',
  SET_ACTIVE_TAB: 'SET_ACTIVE_TAB',
  SET_TAB_UID_MAP: 'SET_TAB_UID_MAP',
  SET_ALL_SECTION_UIDS: 'SET_ALL_SECTION_UIDS',
  SET_ERRORCACHE: 'SET_ERRORCACHE',
  UPDATE_SECTION: 'UPDATE_SECTION',
  SET_CAPABILITY_OVERVIEW: 'SET_CAPABILITY_OVERVIEW',
}

const DataContext = createContext(null)

const initialState = {
  template: null,
  rfiObject: null,
  masterData: null,
  rfiDataFromApi: null,
  activeTab: '',
  errorCache: {},
  tabUidByName: {},
  allSectionUids: new Set(),
  templateDataMapper: {},
  capabilityOverview: {},
}

function reducer(state, action) {
  switch (action.type) {
    case TYPES.SET_TEMPLATE:
      return { ...state, template: action.payload }
    case TYPES.SET_TEMPLATE_MAPPER:
      return { ...state, templateDataMapper: action.payload || {} }
    case TYPES.SET_DATA:
      return { ...state, rfiObject: action.payload }
    case TYPES.SET_MASTER:
      return { ...state, masterData: action.payload }
    case TYPES.SET_CAPABILITY_OVERVIEW:
      return { ...state, capabilityOverview: action.payload }
    case TYPES.SET_DATA_FROM_API:
      return { ...state, rfiDataFromApi: action.payload }
    case TYPES.SET_ACTIVE_TAB:
      return { ...state, activeTab: action.payload || '' }
    case TYPES.SET_TAB_UID_MAP:
      return { ...state, tabUidByName: action.payload || {} }
    case TYPES.SET_ALL_SECTION_UIDS:
      return { ...state, allSectionUids: action.payload || new Set() }
    case TYPES.SET_ERRORCACHE:
      return { ...state, errorCache: action.payload || {} }
    case TYPES.UPDATE_SECTION: {
      const { tabUid, sectionId, sectionData } = action.payload
      const existing = state.rfiObject?.dynamic_sections?.[tabUid] || {}
      return {
        ...state,
        rfiObject: {
          ...state.rfiObject,
          dynamic_sections: {
            ...state.rfiObject?.dynamic_sections,
            [tabUid]: {
              ...existing,
              [sectionId]: sectionData,
            },
          },
        },
      }
    }
    default:
      return state
  }
}

export function DataProvider({ children }) {
  const [state, dispatch] = useReducer(reducer, initialState)
  const value = useMemo(() => ({ state, dispatch }), [state])
  return <DataContext.Provider value={value}>{children}</DataContext.Provider>
}

export function useData() {
  const ctx = useContext(DataContext)
  if (!ctx) throw new Error('useData must be used within <DataProvider>')
  return ctx
}
